import React, { useState } from "react";
import PasswordPolicy from "./PasswordPolicy";
import ResetPassword from "./ResetPassword";

const ChangePassword = () => {
  // Held here so the policy card can tick its rules off as the user types.
  const [newPassword, setNewPassword] = useState("");

  return (
    <div>
      <PasswordPolicy password={newPassword} />
      <ResetPassword onNewPasswordChange={setNewPassword} />
    </div>
  );
};

export default ChangePassword;
